import type { Directive } from 'vue';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import { useButtonsAndLinksTracking } from '../data-layer/hooks/useButtonsAndLinksTracking';

interface TrackRichTextLinksData {
  listener: (event: MouseEvent) => void;
}

declare global {
  interface HTMLElement {
    _trackRichTextLinksData?: TrackRichTextLinksData;
  }
}

const vTrackRichTextLinks: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    if (isServer()) return;

    const componentName = binding.value ?? '';
    const { trackLinkState } = useButtonsAndLinksTracking({ componentName });

    const listener = (event: MouseEvent): void => {
      const link = (event.target as HTMLElement).closest('a');
      if (!link) return;

      const linkText = (link.textContent ?? '').trim();
      const linkUrl = link.getAttribute('href') ?? '';

      trackLinkState(linkText, null, { link_url: linkUrl });
    };

    el.addEventListener('click', listener);
    el._trackRichTextLinksData = { listener };
  },
  unmounted(el) {
    if (el._trackRichTextLinksData?.listener) {
      el.removeEventListener('click', el._trackRichTextLinksData.listener);
      delete el._trackRichTextLinksData;
    }
  },
};

export default vTrackRichTextLinks;
